import { getAllAttributeIds, getFirstSelectableAttributeId } from '../../../Utility/TreeUtility'

export function applyAttributeTreeToDimensions(metadata, getDimensionConfiguration, buildTree, expandAttributes) {
  for (const dimension of metadata) {
    const dimensionConfiguration = getDimensionConfiguration(dimension.Name)
    if (dimensionConfiguration === undefined || !dimensionConfiguration.ExpandLevel) {
      dimension.Attributes.forEach((attribute) => { attribute.IsExpanded = true })
    }
    dimension.Attributes = buildTree(dimension.Attributes)
    if (dimensionConfiguration !== undefined && dimensionConfiguration.ExpandLevel !== undefined && dimensionConfiguration.ExpandLevel >= 0) {
      dimension.Attributes = expandAttributes(dimension.Attributes, dimensionConfiguration.ExpandLevel)
    }
  }
  return metadata
}

/**
 * Default filter selections when metadata loads (full) vs chart change (simplified).
 * @param {object} options.includeAvoidOverlap — add IsAvoidParentOverlap (initial metadata load)
 * @param {object} options.useWhitelistForSingle — single-select uses WhitelistedAttributeIds[0] when set
 */
export function buildDefaultSelectionsForDimensions(dimensions, getDimensionConfiguration, selectAllHideKey, options = {}) {
  const { includeAvoidOverlap = false, useWhitelistForSingle = false } = options
  return dimensions.map((dimension) => {
    const dimensionConfiguration = getDimensionConfiguration(dimension.Name)
    const singleSelect = JSON.parse(dimension.Details).singleSelect || dimensionConfiguration?.SingleSelect
    const selectAllAndHide = dimensionConfiguration?.[selectAllHideKey]
    const whitelistedIds = dimensionConfiguration?.WhitelistedAttributeIds

    let attributes = []
    if (singleSelect) {
      if (useWhitelistForSingle && whitelistedIds?.length > 0) {
        attributes = [whitelistedIds[0]]
      } else {
        attributes = [getFirstSelectableAttributeId(dimension) ?? dimension.Attributes?.[0]?.AttributeID].filter(Boolean)
      }
    } else if (selectAllAndHide) {
      attributes = getAllAttributeIds(dimension)
    }

    const row = {
      DimensionID: dimension.DimensionID,
      IsValid: singleSelect || selectAllAndHide ? true : false,
      Attributes: attributes,
    }
    if (includeAvoidOverlap) {
      row.IsAvoidParentOverlap = !dimensionConfiguration?.SingleSelect && dimensionConfiguration?.AvoidParentOverlap
    }
    return row
  })
}
